import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { RouteBean } from '../model/RouteBean';
import { RouterService } from '../services/router.service';
import { DatePipe } from '@angular/common';
import { EditRouteFormComponent } from '../edit-route-form/edit-route-form.component';

@Component({
  selector: 'app-edit-route',
  templateUrl: './edit-route.component.html',
  styleUrls: ['./edit-route.component.css']
})
export class EditRouteComponent {
  @ViewChild('routeform') editRouteform: EditRouteFormComponent;

  @Output() cancelEvent = new EventEmitter<boolean>();
  @Input() particularRow: any;
  @Output() cancelClickEvent = new EventEmitter<boolean>();
  @Output() submitClickedEvent = new EventEmitter<boolean>();
  history: any;
  cancel() {
    this.cancelEvent.emit(true);
  }

  cancelClick() {
    this.cancelClickEvent.emit(true);
  }
  constructor(private routingService: RouterService, private datePipe: DatePipe) { }

  onTabChange(event: MatTabChangeEvent) {
    if (event.index === 1) {
      //call API
      this.routingService.getHistory(this.particularRow.uuid).then((data) => {
        if (data)
          data.forEach((item: { isActiveChanged: any[]; ruleChange: any[]; changeTime: any }) => {
           item.changeTime = this.datePipe.transform(item.changeTime, 'yyyy-MM-dd HH:mm:ss');

           item.isActiveChanged = [];
           let prevIsActive = item.ruleChange[0].isActive;
           item.ruleChange.forEach((rule: any, i: any) => {
             if (i !== 0 && rule.isActive !== prevIsActive) {
               item.isActiveChanged.push({
                 changedTo: rule.isActive
               });
             }
             prevIsActive = rule.isActive;
           });
         });
       this.history = data;
      })

    }
  }

  editSubmit() {
    this.submitClickedEvent.emit(true);

  }
}
